// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1___ba3cd452802d7544c99","cls2":"CollapsedActivityPreview-cls2___7a59ab32ce3ea979bb8 CollapsedActivityPreview-cls1___ba3cd452802d7544c99"};